export const PLUS_FEATURES = [
  {
    title: 'Remote settings',
    text: `You can change a Frame's settings straight from the app – It's perfect for helping a loved one customize the gift you gave them. Brightness, sleep schedule, volume, and more are all easy to modify with a tap in the app, no matter where you are.`,
  },
  {
    title: 'Albums',
    text: 'Uploading a ton of photos and videos? Create albums to easily view, organize, and share your photos on demand.',
  },
  {
    title: 'Slideshow mirroring',
    text: `Share photos from the Skylight app straight to your television. Perfect for family visits.`,
  },
]
